// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__s0SVx","logo--black":"style_logo--black__M-XQy","logoBlack":"style_logo--black__M-XQy"};